// DACH countries (Germany, Austria, Switzerland) + Liechtenstein
export const countries = [
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹' },
  { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮' }
];

// Helper function to get country by code
/** @param {string} code */
export function getCountryByCode(code) {
  return countries.find((c) => c.code === code);
}

// Helper function to get country name by code
/** @param {string} code */
export function getCountryName(code) {
  const country = getCountryByCode(code);
  return country ? country.name : code;
}
